/* eslint-disable react/jsx-props-no-spreading */
import cx from 'classnames';
import * as _ from 'lodash';
import type { UseComboboxPropGetters } from 'downshift';
import type { RefObject, VoidFunctionComponent } from 'react';

import InputBase from '../generic/Forms/InputBase';
import { LoadingBar } from '../generic/LoadingBar/LoadingBar';
import type { CommandPaletteSearchFEResult } from '../../../shared/CommandPalette/types';

import styles from './SearchInput.module.less';

type Props = ReturnType<UseComboboxPropGetters<CommandPaletteSearchFEResult>['getInputProps']> & {
  inputRef: RefObject<HTMLInputElement>;
  isLoading: boolean;
};

/**
 * The search input component for the command palette.
 */
const SearchInput: VoidFunctionComponent<Props> = ({ inputRef, value, isLoading, ...props }) => {
  return (
    <>
      <div className={cx(styles.search, { [styles.searchLoading]: isLoading })}>
        <InputBase
          label="Search FOSSA"
          onChange={_.noop}
          value={value}
        >
          {({ className, ...inputProps }) => (
            <input
              {...inputProps}
              {...props}
              className={cx(className, styles.searchInput)}
              placeholder="Search or jump to..."
              ref={inputRef}
            />
          )}
        </InputBase>
      </div>
      <LoadingBar isVisible={isLoading} />
    </>
  );
};

export default SearchInput;
